import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Select,
  SimpleGrid,
  Stack,
  Table,
  Tbody,
  Td, Th,
  Thead,
  Tr,
  useColorModeValue
} from "@chakra-ui/react";
import { PessoaContaFinanceiro } from "models/pessoa_conta_type";
import { useState } from "react";
import InputMask from "react-input-mask";

interface IContaFinanceiroData {
  contaList: PessoaContaFinanceiro[];
  bancoRef: any;
  agenciaRef: any;
  tipoRef: any;
  numeroContaRef: any;
  titularRef: any;
  tipoPessoaRef: any;
  documentoContaRef: any;
  descricaoRef: any;
  obsRef: any;
  textColor: string;
  adcionarConta: () => void;
  deleteConta: (conta: PessoaContaFinanceiro) => void;
}

const ContaFinanceiroData = ({
  adcionarConta,
  agenciaRef,
  bancoRef,
  contaList,
  deleteConta,
  descricaoRef,
  documentoContaRef,
  numeroContaRef,
  obsRef,
  tipoPessoaRef,
  tipoRef,
  titularRef,
  textColor,
}: IContaFinanceiroData) => {
  const [agencia, setAgencia] = useState("");
  const [banco, setBanco] = useState("");
  const [descricao, setDescricao] = useState("");
  const [documento, setDocumento] = useState("");
  const [numero, setNumero] = useState("");
  const [obs, setObs] = useState("");
  const [tipoPessoa, setTipoPessoa] = useState("");
  const [tipo, setTipo] = useState("");
  const [titular, setTitular] = useState("");

  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  

  const [mask, setMask] = useState("");

  const showInput = (selected: string) => {
    changeInput( "tipoPessoa", selected);

    if (selected === "2") {
      setMask("99.999.999/9999-99");
    } else {
      setMask("999.999.999-99");
    }
  };

  const changeInput = (type: string, value: string) => {
    switch (type) {
      case "agencia":
        setAgencia(value);
        agenciaRef.current =  value;
        break;
      case "banco":
        setBanco(value);
        bancoRef.current =  value;
        break;
      case "descricao":
        setDescricao(value);
        descricaoRef.current =  value;
        break;
      case "documento":
        setDocumento(value);
        documentoContaRef.current =  value;
        break;
      case "numero":
        setNumero(value);
        numeroContaRef.current =  value;
        break;
      case "obs":
        setObs(value);
        obsRef.current = value;
        break;
      case "tipoPessoa":
        setTipoPessoa(value);
        tipoPessoaRef.current =  value;
        break;
      case "tipo":
        setTipo(value);
        tipoRef.current = value;
        break;
      case "titular":
        setTitular(value);
        titularRef.current = value;
        break;
    }
  };

  const cleanInput = () => {
    setAgencia("");
    setBanco("");
    setDescricao("");
    setDocumento("");
    setNumero("");
    setObs("");
    setTipoPessoa("");
    setTipo("");
    setTitular("");

    titularRef.current = "";
    tipoRef.current  = "";
    tipoPessoaRef.current = "";
    obsRef.current  = "";
    numeroContaRef.current  = "";
    documentoContaRef.current  = "";
    descricaoRef.current  = "";
    bancoRef.current = "";
    agenciaRef.current  = "";;
  };

  const submitConta = () => {
    adcionarConta();
    cleanInput();
  };

  return (
    <AccordionItem>
      <h2>
        <AccordionButton>
          <Box flex="1" textAlign="left" color={"#422AFB"} fontWeight={"bold"}>
            Dados Bancários
          </Box>
          <AccordionIcon color={"#422AFB"} />
        </AccordionButton>
      </h2>
      <AccordionPanel pb={4}>
        <Stack>
          <Button
            marginY={10}
            variant={"outline"}
            onClick={() => {
              submitConta();
            }}
            alignSelf={"flex-end"}
            colorScheme="brand"
            isLoading={false}
          >
            Adicionar Conta
          </Button>
        </Stack>

        <SimpleGrid columns={4} spacing={4}>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Tipo de Conta
            </FormLabel>

            <Select
              size="md"
              onChange={(e) => changeInput( "tipo", e.target.value)}
              value={tipo}
              ref={tipoRef}
            >
              <option value={"0"}>SELECIONE O TIPO</option>
              <option value={"1"}>CORRENTE</option>
              <option value={"2"}>POUPANÇA</option>
            </Select>
          </FormControl>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Tipo de Pessoa
            </FormLabel>

            <Select
              size="md"
              onChange={(e) => {
                showInput(e.target.value);
              }}
              value={tipoPessoa}
              ref={tipoPessoaRef}
            >
              <option value={"0"}>SELECIONE O TIPO DE PESSOA</option>
              <option value={"1"}>FÍSICA</option>
              <option value={"2"}>JÚRIDICA</option>
            </Select>
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
            >
              Descrição
            </FormLabel>
            <Input
              value={descricao}
              fontSize="sm"
              ref={descricaoRef}
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Preencha a Descrição"
              onChange={(e) => changeInput("descricao", e.target.value)}
              fontWeight="500"
              size="md"
            />
          </FormControl>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
            >
              Titular
            </FormLabel>
            <Input
              value={titular}
              ref={titularRef}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Preencha o titular"
              onChange={(e) => changeInput("titular", e.target.value)}
              fontWeight="500"
              size="md"
            />
          </FormControl>
        </SimpleGrid>
        <SimpleGrid columns={5} spacing={4} mt={4}>

        <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Documento
              </FormLabel>
              <Input
                value={documento}
                ref={documentoContaRef}
                isRequired={false}
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder={
                  mask === "999.999.999-99"
                    ? "Preencha o CPF"
                    : "Preencha o CNPJ"
                }
                onChange={(e) => changeInput("documento", e.target.value)}
                fontWeight="500"
                size="md"
                as={InputMask}
                mask={mask}
              />
            </FormControl>
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
              >
                Banco
              </FormLabel>
              <Input
                value={banco}
                ref={bancoRef}
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder="Preencha o código do banco"
                onChange={(e) => changeInput("banco", e.target.value)}
                fontWeight="500"
                size="md"
              />
            </FormControl>
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
              >
                Agência
              </FormLabel>
              <Input
                value={agencia}
                ref={agenciaRef}
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder="Preencha o código da Agência"
                onChange={(e) => changeInput("agencia", e.target.value)}
                fontWeight="500"
                size="md"
              />
            </FormControl>
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
              >
                Número da Conta
              </FormLabel>
              <Input
                value={numero}
                ref={numeroContaRef}
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder="Preencha o numero da conta/cartão"
                onChange={(e) => changeInput("numero", e.target.value)}
                mb="16px"
                fontWeight="500"
                size="md"
              />
            </FormControl>

            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
              >
                Observação
              </FormLabel>
              <Input
                value={obs}
                ref={obsRef}
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder="Preencha a Observação, pix e etc"
                onChange={(e) => changeInput("obs", e.target.value)}
                mb="16px"
                fontWeight="500"
                size="md"
              />
            </FormControl>
        </SimpleGrid>

        <Box>
          <Table variant="striped" color="gray.500" mb="24px" mt="12px">
            <Thead>
              <Tr>
                <Th pe="10px" borderColor={borderColor} cursor="pointer">
                  <Flex
                    justifyContent="space-between"
                    align="center"
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color="gray.400"
                  >
                    #DESCRICAO
                  </Flex>
                </Th>
                <Th pe="10px" borderColor={borderColor} cursor="pointer">
                  <Flex
                    justifyContent="space-between"
                    align="center"
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color="gray.400"
                  >
                    #TITULAR
                  </Flex>
                </Th>

                <Th pe="10px" borderColor={borderColor} cursor="pointer">
                  <Flex
                    justifyContent="space-between"
                    align="center"
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color="gray.400"
                  >
                    #BANCO
                  </Flex>
                </Th>

                <Th pe="10px" borderColor={borderColor} cursor="pointer">
                  <Flex
                    justifyContent="space-between"
                    align="center"
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color="gray.400"
                  >
                    #AGENCIA
                  </Flex>
                </Th>

                <Th pe="10px" borderColor={borderColor} cursor="pointer">
                  <Flex
                    justifyContent="space-between"
                    align="center"
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color="gray.400"
                  >
                    #NUMERO
                  </Flex>
                </Th>

                <Th pe="10px" borderColor={borderColor} cursor="pointer">
                  <Flex
                    justifyContent="space-between"
                    align="center"
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color="gray.400"
                  >
                    #DOCUMENTO
                  </Flex>
                </Th>

                <Th pe="10px" borderColor={borderColor} cursor="pointer">
                  <Flex
                    justifyContent="space-between"
                    align="center"
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color="gray.400"
                  >
                    #OBS
                  </Flex>
                </Th>

                <Th pe="10px" borderColor={borderColor} cursor="pointer">
                  <Flex
                    justifyContent="space-between"
                    align="center"
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color="gray.400"
                  >
                    #OPÇÕES
                  </Flex>
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {contaList?.map((item, index) => {
                return (
                  <Tr key={`${item.id}-${item}-${index}`}>
                    <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                      {item.descricao}
                    </Td>
                    <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                      {item.titular}
                    </Td>

                    <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                      {item.banco}
                    </Td>

                    <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                      {item.agencia}
                    </Td>
                    <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                      {item.numero}
                    </Td>

                    <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                      {item.documento}
                    </Td>

                    <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                      {item.obs}
                    </Td>

                    <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                      <Button
                        onClick={() => {
                          deleteConta(item);
                        }}
                        colorScheme="red"
                        variant="ghost"
                        ml="1"
                      >
                        Excluir
                      </Button>
                    </Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </Box>
      </AccordionPanel>
    </AccordionItem>
  );
};
export default ContaFinanceiroData;
